'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Root = require('./Root');

var _Root2 = _interopRequireDefault(_Root);

var _createBrowserHistory = require('history/createBrowserHistory');

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('babel-polyfill');


if (module.hot) {
  module.hot.accept();
}

var history = (0, _createBrowserHistory2.default)();

_reactDom2.default.render(_react2.default.createElement(_Root2.default, { history: history }), document.getElementById('root'));


//////////////////
// WEBPACK FOOTER
// ./lib/app/index.js
// module id = 408
// module chunks = 0